import logger from '../logger';
import { x } from '../utils';
import profiler from './profiler';

const log = logger.get('execution-engine:job-queue', {
    level: logger.INFO,
});

export default function JobQueue(collection, identifier, pendingJobs, queuedJobs) {
    const queue = [];

    this.collection = collection;
    this.identifier = identifier;

    this.enqueue = jobDescription => {
        log.debug(`QUEUE - queue: ${jobDescription}`);

        const queueEmpty = this.isEmpty();
        queue.push(jobDescription);
        queuedJobs.increase();

        if (profiler.isEnabled()) {
            profiler.data()[jobDescription.jobNumber] = {
                enqueued: Date.now(),
                info: jobDescription.toString(),
                collection: jobDescription.collection,
                queueSize: pendingJobs.instrumentation().getQueueSize(),
            };
        }

        if (queueEmpty) {
            executeJob();
        }
    };

    this.isEmpty = () => queue.length === 0;

    this.instrumentation = () => ({
        size: queue.length,
        queue: queue,
        getSizeWithoutWaitJobs: () => queue.filter(elem => !elem.toString().match(/^WAIT /)).length,
    });

    /**
     * Will run the job that is first in the queue
     *
     * If it is an async job, a check is first made to make sure
     * that we do not have reached the 'maxNbrOfPendingJobs'. If max has been reached,
     * the job is enqueued on the pendingJobsState. For synchronous jobs, we do not check
     * maxNbrOfPendingJobs.
     */
    function executeJob() {
        if (queue.length === 0) {
            return;
        }

        const jobDescription = queue[0];
        const job = jobDescription.job;

        if (jobDescription.async) {
            if (pendingJobs.isFull()) {
                pendingJobs.enqueue({ execute: executeJob, jobDescription: jobDescription });
                return;
            }
            if (profiler.isEnabled()) {
                const jobData = profiler.data()[jobDescription.jobNumber] || {};
                jobData.started = Date.now();
                profiler.data()[jobDescription.jobNumber] = jobData;
            }
            log.debug(`QUEUE - execute async: ${jobDescription}`);
            pendingJobs.increase();
            job(x.once(dequeue));
        } else {
            log.debug(`QUEUE - execute: ${jobDescription}`);
            pendingJobs.increase();
            job();
            dequeue();
        }
    }

    /**
     * This runs after a job has finished. It will shift the queue and
     * call executeJob in order to proceed with the queue
     */
    function dequeue() {
        if (queue.length === 0) {
            return;
        }
        const jobDescription = queue.shift();
        if (profiler.isEnabled()) {
            const jobData = profiler.data()[jobDescription.jobNumber] || {};
            jobData.finished = Date.now();

            profiler.data()[jobDescription.jobNumber] = jobData;
        }

        log.debug(`QUEUE - done: ${jobDescription}`);
        pendingJobs.decrease();
        queuedJobs.decrease();

        executeJob();
    }
}
